import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/mapa/banner-mapas-webp.webp")